import { makeAutoObservable } from "mobx";
import ConsoleStyles from "core/constants/console-styles";
import { getActiveFeatures } from "core/features";
import ActiveFeatures from "core/features/actives-features";
import User, { getUser } from "core/models/user";

const areaPrefix = "area-";

class AppStore {
    title = "";
    header = "";
    bodyCssName = "";
    coreBodyCssName = "";
    area = "";
    user: User | undefined = undefined;
    features: ActiveFeatures = {
        fixError: false,
        statements: false,
        downloadStatements: false,
        users: false,
        queries: false,
        pay: false,
        activityLog: false
    };

    constructor() {
        makeAutoObservable(this);
    }

    get permissionCss() {
        const can = this.user?.can;

        if (!can) {
            return "";
        }

        const css: string[] = [];

        let canManage = false;

        const show = this.features;

        if (show.users) {
            canManage = true;
            css.push("can-users");
        }

        if (show.activityLog) {
            css.push("can-activity-log");
            canManage = true;
        }

        if (show.statements) {
            css.push("can-statements");
            canManage = true;
        }

        if (show.pay) {
            css.push("can-pay");
        }

        if (show.queries) {
            css.push("can-queries");
        }

        if (canManage) {
            css.push("can-manage");
        }

        //isEnabled(Feature.subscriptions)

        return css.join(" ");
    }

    updateArea(value: string) {
        this.area = value;
        this.updateBodyCssName(this.bodyCssName);
    }

    updateCoreBodyCssName(value: string) {
        this.coreBodyCssName = value;
        this.updateBodyCssName(value);
    }

    appendBodyCssName(value: string) {
        if (this.coreBodyCssName) {
            value = !this.coreBodyCssName.startsWith(value) ? `${this.coreBodyCssName} ${value}` : value;
        }

        this.updateBodyCssName(value);
    }

    updateBodyCssName(value: string) {
        this.bodyCssName = value;

        if (this.area) {
            value += ` ${areaPrefix}${this.area}`;
        }

        // value += " " + this.permissionCss;

        document.body.className = value.trim();
    }

    updateTitle(value: string, usePrefix = true) {
        this.title = usePrefix ? `MyDStv Business ${value}` : value;
        document.title = this.title;
    }

    clearHeader() {
        this.updateHeader("");
    }

    updateHeader(value: string) {
        this.header = value;
    }

    update(value: User | undefined) {
        this.user = value;
    }

    signOut() {
        this.user = undefined;
    }

    initializeUser() {
        const user = getUser();
        this.update(user);
        this.features = getActiveFeatures();

        console.log("%cInitializing User", ConsoleStyles.important, user);
    }
}

export default AppStore;
